import { useState } from 'react'
import { Link } from 'react-router-dom'
import AwarenessRegisterModal from '../AwarenessRegisterModal'

const AwarenessCtaBanner = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <section className="py-3 sm:py-5 px-4 sm:px-6 lg:px-8 max-w-8xl mx-auto select-none">
      <div className="bg-gradient-to-r from-[#FFF5ED] via-[#FFF9F3] to-[#FFF2E8] rounded-2xl sm:rounded-3xl p-5 sm:p-7 lg:p-8 text-slate-800 shadow-xs border border-orange-200/60 relative overflow-hidden text-left">
        {/* Subtle background glow */}
        <div className="absolute top-0 right-0 w-80 h-80 bg-brand-orange-500/5 rounded-full blur-3xl pointer-events-none -mr-16 -mt-16" />

        <div className="relative z-10 flex flex-col lg:flex-row lg:items-center justify-between gap-5 lg:gap-8">
          
          {/* Left Text Column */}
          <div className="max-w-2xl space-y-2">
            <h2 className="text-xl sm:text-2.5xl lg:text-[28px] font-bold text-slate-900 leading-tight">
              Host an Animal Welfare &amp; Rabies Awareness Session for Schools, RWAs &amp; Institutions
            </h2>
            <p className="text-xs sm:text-sm md:text-base text-slate-600 font-medium leading-relaxed max-w-xl">
              Conduct an interactive coexistence, bite safety, and responsible feeding workshop for your students, society residents, or campus team.
            </p>
          </div>

          {/* Right Action Column */}
          <div className="shrink-0 flex items-center gap-3 relative">
            <button
              onClick={() => setIsModalOpen(true)}
              className="relative z-10 w-auto inline-flex items-center justify-center gap-1.5 px-5 py-2.5 sm:px-6 sm:py-3 bg-brand-orange-700 hover:bg-brand-orange-850 text-white font-bold text-xs sm:text-sm rounded-full shadow-md hover:shadow-lg transition-all cursor-pointer tracking-wide"
            >
              <span>Register Program</span>
              <svg className="w-3.5 h-3.5 sm:w-4 sm:h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </button>
          </div>

        </div>
      </div>

      {/* Registration Modal */}
      <AwarenessRegisterModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  )
}

export default AwarenessCtaBanner
